import React from "react";
import InlineInputGroup from "components/forms/FormFields/InlineInputGroup";
import ImageUploadType from "api/models/ImageUploadType";
import { Ratio } from "components/forms/FormFields/PictureGallery/helpers";
import SinglePicture from "components/forms/FormFields/SinglePicture";
import strings from "localisation/strings";

interface GlassUiPictureProps {
  showGlassUiImagePicker: boolean;
  ratio?: Ratio;
  getGlassUiImageProps: () => {
    imageUrl?: string | null;
    setImageUrl?: (image: string | null) => void;
  };
}

const GlassUiPicture = ({
  showGlassUiImagePicker,
  getGlassUiImageProps,
  ratio = Ratio.ratio5_7,
}: GlassUiPictureProps) => {
  if (!showGlassUiImagePicker) {
    return null;
  }

  return (
    <InlineInputGroup
      labelMargin="0px 0px 0px 5px"
      placeholder={strings("glassUi.picture.placeholder")}
      wrapText
    >
      <SinglePicture
        {...getGlassUiImageProps()}
        container={ImageUploadType.POSTS}
        withCropAndZoom
        ratio={ratio}
        width="70%"
      />
    </InlineInputGroup>
  );
};

export default GlassUiPicture;
